import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import "./Auth.css";

function RegisterPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [nickname, setNickname] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !password || !nickname) {
      alert("모든 필드를 입력해주세요.");
      return;
    }

    const { data: exists } = await supabase
    .from("users")
    .select("id")
    .eq("email", email)
    .single();

    if (exists) {
      alert("이미 가입된 이메일입니다.");
      return;
    }

    // 1) Supabase Auth 회원가입
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
    });

    if (error) {
      alert("회원가입 실패: " + error.message);
      return;
    }

    const user = data.user;
    if (!user) {
      alert("회원가입 오류: 사용자 정보가 없습니다.");
      return;
    }

    // 2) users 테이블에 추가 정보 저장 (nickname 포함)
    const { error: insertError } = await supabase.from("users").insert({
      id: user.id,
      email,
      nickname,
      created_at: new Date(),
    });

    if (insertError) {
      alert("사용자 정보 저장 중 오류가 발생했습니다: " + insertError.message);
      return;
    }

    alert("회원가입이 완료되었습니다!");
    navigate("/login");
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title">회원가입</h1>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>닉네임</label>
            <input
              type="text"
              className="form-input"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              placeholder="사용하실 이름을 입력하세요"
            />
          </div>

          <div className="form-group">
            <label>이메일</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email@example.com"
            />
          </div>

          <div className="form-group">
            <label>비밀번호</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="비밀번호를 입력하세요"
            />
          </div>

          <button type="submit" className="btn-submit">
            가입하기
          </button>
        </form>

        <div className="auth-footer">
          이미 계정이 있으신가요?
          <span className="auth-link" onClick={() => navigate("/login")}>
            로그인
          </span>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
